import { SET_CLIENT_ABOUT } from "../actions/action-types.js";

export default function clientAbout(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_ABOUT:
            return (state = payload)
        default:
            return state
    }
}